import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { addLocale } from "primereact/api";
import Services from "../../service/Services";
import { CambiarFormatoFecha, EstandarFormatoFecha } from "../Funciones";

const ModalAddServices = ({ listSevicesProp, setListServicesProp, dateStartValidateRangeProp, dateEndValidateRangeProp, disabledServicesProp }) => {

    const [service, setService] = useState([]);

    const getService = new Services()
    const [runRender, setRunRender] = useState(0)

    useEffect(() => {
        getService.getServices().then(data => setService(data))
        setDataServices(listSevicesProp)
    }, [listSevicesProp, runRender])// eslint-disable-line react-hooks/exhaustive-deps

    const [displayBasic, setDisplayBasicAddServices] = useState(false);
    const [setPosition] = useState('center');

    const dialogFuncMap = {
        'displayBasic': setDisplayBasicAddServices,
    }

    const onClick = (name, position) => {
        dialogFuncMap[`${name}`](true);
        if (position) {
            setPosition(position);
        }
    }

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }

    const [validateChange, setValidateChange] = useState(false)

    const [dataServices, setDataServices] = useState(listSevicesProp)

    //Obtener datos del select tipo de clientes

    const [selectedService, setSelectedService] = useState({
        id: '',
        name: ''
    });

    const services = service.map(item => {
        const av = { name: item.descripcion, id: item.id }
        return av
    })

    const onServiceChange = (e) => {
        setSelectedService(e.value);
        setValidateChange(true)
    }

    const optionsDisabledServices = (e) => {
        var disabled = false
        dataServices.forEach(element =>{
            if (element.id === e.id) {
                disabled = true
            }
        })
        return disabled
    }

    // calendar de fecha inicio vigencia

    const [dateStart, setDateStart] = useState(null);

    const onDateStartChange = (e) => {
        let date = e.value
        setDateStart(date)
        setValidateChange(true)
    }

    // calendar de fecha fin vigencia

    const [dateEnd, setDateEnd] = useState(null);

    const onDateEndChange = (e) => {
        let date = e.value
        setDateEnd(date)
        setValidateChange(true)
    }

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    //Validar si hubo algun cambio 

    var changes = false

    if (validateChange === true) {
        changes = true
    }

    //Almacenamos los valores para enviarlos por props

    /* const idService = selectedService.id */

    const resetData = () => {
        setSelectedService({
            id: '',
            name: ''
        })
        setDateStart(null)
        setDateEnd(null)
        setValidateChange(false)
    }

    // Modal para el botón Back

    const ModalBack = () => {
        const [displayConfirmation, setDisplayConfirmation] = useState(false);
        const [setPosition] = useState('center');

        const dialogFuncMap = {
            'displayConfirmation': setDisplayConfirmation,
        }

        const onClick = (name, position) => {
            dialogFuncMap[`${name}`](true);
            if (position) {
                setPosition(position);
            }
        }

        const onHide = (name) => {
            dialogFuncMap[`${name}`](false);
        }

        const Back = (name) => {
            resetData()
            setListServicesProp(listSevicesProp)
            dialogFuncMap[`${name}`](false);
            setDisplayBasicAddServices(false)
        }

        const renderFooter = (name) => {
            return (
                <div>
                    <Button label="Cancelar" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
                    <Button label="Aceptar" icon="pi pi-check" onClick={() => Back(name)} autoFocus />
                </div>
            );
        }

        return (
            <>
                <Button label="Regresar" icon="pi pi-times" onClick={() => onClick('displayConfirmation')} className="p-button-text" />
                <Dialog className="dialog-demo" header="Advertencia" visible={displayConfirmation} modal style={{}} footer={renderFooter('displayConfirmation')} onHide={() => onHide('displayConfirmation')}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                        <span style={{ textAlign: 'center' }}>No se ha guardado la información registrada, ¿desea continuar?</span>
                    </div>
                </Dialog>
            </>
        )
    }

    // Función que agrega los servicios a la tabla

    const AddServices = () => {
        var obj = {
            id: selectedService.id,
            service: selectedService.name,
            sendDateStart: CambiarFormatoFecha(dateStart),
            sendDateEnd: CambiarFormatoFecha(dateEnd),
            dateStart: EstandarFormatoFecha(dateStart),
            dateEnd: EstandarFormatoFecha(dateEnd)
        }
        resetData()
        setValidateChange(true)
        setDataServices([...dataServices, obj])
    }

    const DeleteServices = (id) =>{
        var newDataSevices = dataServices.filter((object) => object.id !== id)
        setDataServices(newDataSevices)
        setValidateChange(true)
    }

    const SaveServices = (name) => {
        onHide(name)
        setListServicesProp(dataServices)
        setValidateChange(false)
    }

    const renderFooter = (name) => {
        return (
            <div>
                {changes ?
                    <ModalBack />
                    :
                    <Button label="Regresar" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
                }
                {dataServices.length !== 0 ?
                    <Button label="Guardar" icon="pi pi-save" onClick={() => SaveServices(name)} />
                    :
                    ""
                }
            </div>
        );
    }
    const deleteService = (rowData) =>{
        return(
            <Button icon="pi pi-trash" onClick={() => DeleteServices(rowData.id)} className="p-button-danger"/>
        )
    }

    var dateStartError = false
    var dateStartMessage = ''

    const validateRangeDate = () => {
        var newDateStart = CambiarFormatoFecha(dateStart)
        var newDateEnd = CambiarFormatoFecha(dateEnd)

        if (newDateStart >= dateStartValidateRangeProp && newDateStart <= dateEndValidateRangeProp &&
            newDateEnd >= dateStartValidateRangeProp && newDateEnd <= dateEndValidateRangeProp) {
            dateStartError = false
            dateStartMessage = ''
        } else {
            dateStartError = true
            dateStartMessage = 'La fecha de inicio y fin están fuera del rango de fechas del contrato'
        }
    }

    if (dateStart !== null && dateEnd !== null) {
        if (dateStart > dateEnd) {
            dateStartError = true
            dateStartMessage = 'La fecha inicio vigencia no puede ser mayor a la fecha fin de vigencia'
        } else {
            validateRangeDate()
        }
    }

    // validación para crear

    var registerPermission = false

    if (dateStartError === false && selectedService.id !== '' && dateStart !== null && dateEnd !== null) {
        registerPermission = true
    }

    return (
        <>
            <Button icon="pi pi-plus" className="btnAdd" onClick={() => {
                onClick('displayBasic')
                setRunRender(runRender +1)
            }}  disabled={disabledServicesProp} />
            <Dialog className="modal" header="Asociar servicios" visible={displayBasic} style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '640px': '75vw' }} footer={renderFooter('displayBasic')} onHide={() => onHide('displayBasic')}>
                <div className="p-fluid p-formgrid p-grid">
                    <form style={{ display: 'contents' }} >
                        <div className="p-field p-col-12 p-md-4">
                            <label className="labels" >Servicios<span className="require">*</span></label>
                            <Dropdown value={selectedService} options={services} onChange={onServiceChange} placeholder="Seleccione un servicio" filter
                                className="p-column-filter " emptyMessage="No hay resultados" name="Client" optionLabel="name" optionDisabled={optionsDisabledServices}
                            />
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <label className="labels" >Fecha inicio vigencia<span className="require">*</span></label>
                            <Calendar placeholder="Seleccione una fecha" value={dateStart} onChange={onDateStartChange} dateFormat="dd-mm-yy" locale="es"
                                className={dateStartError ? "p-invalid" : ""} />
                            <p className="mensajeError">{dateStartError ? dateStartMessage : ""}</p>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <label className="labels" >Fecha fin vigencia<span className="require">*</span></label>
                            <div className="p-inputgroup">
                                <Calendar placeholder="Seleccione una fecha" value={dateEnd} onChange={onDateEndChange} dateFormat="dd-mm-yy" locale="es"
                                    className={""}
                                />
                                {registerPermission ?
                                    <Button icon="pi pi-plus" className="btnAdd" onClick={() => AddServices()} />
                                    :
                                    ""
                                }
                            </div>
                        </div>
                    </form>
                </div>
                <div className="datatable-responsive-demo">
                    <div className="card">
                        <DataTable value={dataServices} emptyMessage="No se registran datos" paginator rows={3}>
                            <Column className="columna" field="service" header="Servicio" />
                            <Column className="columna" field="dateStart" header="Fecha inico vigencia" />
                            <Column className="columna" field="dateEnd" header="Fecha fin vigencia"/>
                            <Column className="columna" header="Eliminar" body={deleteService}/>
                        </DataTable>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default ModalAddServices